import React from "react";
import AdminCheckbox from "../AdminCheckbox";

const PermissionCell = ({
  categoryId,
  itemId,
  permissionType,
  isEnabled,
  onPermissionChange,
  isCategory = false,
  disabled = false,
}) => {
  return (
    <td className="p-1">
      <div className="flex justify-center">
        <AdminCheckbox
          checked={isEnabled || false}
          onChange={(e) => {
            onPermissionChange(
              categoryId,
              itemId,
              permissionType,
              e.target.checked
            );
          }}
          disabled={disabled}
        />
      </div>
    </td>
  );
};

export default PermissionCell;
